import {
  CompositeTableTemplate,
  renderCellGrayZeros,
} from 'app/common/templates-next/table-template'
import { ReportFinancesDataReplenishmentCommon } from 'app/dataTypes/reports/data/common/financesSummaryReplenishment'

import { useBySchoolOrClassesTableData } from './useBySchoolOrClassesTableData'

type Props = {
  data: ReportFinancesDataReplenishmentCommon
  currency: string
}

export const BySchoolOrClassesTable = ({ data, currency }: Props) => {
  const tableData = useBySchoolOrClassesTableData(data, currency)

  return (
    <CompositeTableTemplate
      data={tableData}
      renderCell={renderCellGrayZeros}
      renderFooterCell={renderCellGrayZeros}
      borderTop
    />
  )
}
